export function callNumber(

    mobile

){

    if(!mobile){

        return;

    }

    window.open(

        `tel:${mobile}`

    );

}